import { render, staticRenderFns } from "./ExcBaseTextarea.vue?vue&type=template&id=08dfcc4f&scoped=true&"
import script from "./ExcBaseTextarea.vue?vue&type=script&lang=js&"
export * from "./ExcBaseTextarea.vue?vue&type=script&lang=js&"
import style0 from "./ExcBaseTextarea.vue?vue&type=style&index=0&id=08dfcc4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dfcc4f",
  null
  
)

export default component.exports